"use client"

import { motion } from "framer-motion"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Mail, Phone, Printer } from "lucide-react"

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 },
  },
}

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

export default function CateringPage() {
  return (
    <div className="min-h-screen py-12 md:py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-balance text-foreground font-[family-name:var(--font-display)]">
              Catering Services
            </h1>
            <p className="text-lg text-muted-foreground text-pretty">
              Let us bring the soul food experience to your next event
            </p>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeInUp}
          >
            <Card className="mb-8">
              <CardHeader>
                <CardTitle className="text-2xl">Full Menu Catering Available</CardTitle>
                <CardDescription className="text-base">
                  Perfect for events, parties, and gatherings of all sizes
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-lg text-muted-foreground leading-relaxed">
                  Good Thangz Cookin offers catering with full menu availability. All catering orders must be placed in
                  advance.
                </p>
                <p className="text-lg text-muted-foreground leading-relaxed">
                  Whether you're hosting a family reunion, corporate event, or special celebration, we'll bring
                  authentic soul food that your guests will love. Our catering menu features all of your favorite
                  dishes, prepared fresh and delivered with care.
                </p>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeInUp}
          >
            <Card>
              <CardHeader>
                <CardTitle className="text-2xl">Get in Touch</CardTitle>
                <CardDescription className="text-base">Contact us to discuss your catering needs</CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                <motion.div
                  variants={staggerContainer}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  className="grid gap-4 sm:grid-cols-3"
                >
                  <motion.div variants={fadeInUp}>
                    <Button asChild size="lg" className="w-full bg-accent hover:bg-accent/90 text-accent-foreground">
                      <a href="tel:+15139794101" className="flex items-center justify-center gap-2">
                        <Phone className="h-5 w-5" />
                        Call Us
                      </a>
                    </Button>
                  </motion.div>
                  <motion.div variants={fadeInUp}>
                    <Button
                      asChild
                      size="lg"
                      variant="outline"
                      className="w-full border-accent text-accent hover:bg-accent hover:text-accent-foreground bg-transparent"
                    >
                      <a href="mailto:contact@goodthangzcookin.com" className="flex items-center justify-center gap-2">
                        <Mail className="h-5 w-5" />
                        Email Us
                      </a>
                    </Button>
                  </motion.div>
                  <motion.div variants={fadeInUp}>
                    <Button
                      asChild
                      size="lg"
                      variant="outline"
                      className="w-full border-accent text-accent hover:bg-accent hover:text-accent-foreground bg-transparent"
                    >
                      <a href="tel:+15139563764" className="flex items-center justify-center gap-2">
                        <Printer className="h-5 w-5" />
                        Fax Us
                      </a>
                    </Button>
                  </motion.div>
                </motion.div>

                <div className="pt-6 border-t space-y-3 text-center">
                  <p className="text-sm text-muted-foreground">
                    <strong className="text-foreground">Phone:</strong>{" "}
                    <a href="tel:+15139794101" className="hover:text-accent transition-colors">
                      (513) 979-4101
                    </a>
                  </p>
                  <p className="text-sm text-muted-foreground">
                    <strong className="text-foreground">Email:</strong>{" "}
                    <a href="mailto:contact@goodthangzcookin.com" className="hover:text-accent transition-colors">
                      contact@goodthangzcookin.com
                    </a>
                  </p>
                  <p className="text-sm text-muted-foreground">
                    <strong className="text-foreground">Fax:</strong> (513) 956-3764
                  </p>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </div>
  )
}
